module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "annotations transparent-panel"
  }, [(_vm.annotationsActive) ? _c('div', {
    staticClass: "annotations-button-panel"
  }, [_c('div', {
    staticClass: "annotations-title"
  }, [_vm._v(_vm._s(_vm.$t("annotations.title")))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.open),
      expression: "!open"
    }],
    staticClass: "button actions",
    on: {
      "click": _vm.clearVector
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.open),
      expression: "!open"
    }],
    staticClass: "button actions",
    on: {
      "click": _vm.toggleLayer
    }
  }, [(_vm.visible) ? _c('icon', {
    attrs: {
      "name": "eye"
    }
  }) : _c('icon', {
    attrs: {
      "name": "eye-slash"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.togglePanel
    }
  }, [(_vm.open) ? _c('icon', {
    attrs: {
      "name": "angle-up"
    }
  }) : _c('icon', {
    attrs: {
      "name": "angle-down"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "annotations-panel"
  }, [_c('div', {
    staticClass: "geometry-types-selection"
  }, _vm._l((_vm.geometryTypes), function(geomType, idx) {
    return _c('div', {
      key: geomType,
      staticClass: "selector-button",
      class: {
        active: _vm.curGeomType === geomType, last: idx === _vm.geometryTypes.length - 1
      },
      on: {
        "click": function($event) {
          _vm.curGeomType = geomType
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t(("annotations.geomTypes." + geomType))) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "feature-list"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ol-popup",
    attrs: {
      "id": "popup-annotations"
    }
  }, [_c('span', {
    staticClass: "ol-popup-closer",
    on: {
      "click": function($event) {
        return _vm.displayPopup(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "popup-content-annotations"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.featureText),
      expression: "featureText"
    }],
    attrs: {
      "placeholder": "Add label",
      "type": "text"
    },
    domProps: {
      "value": (_vm.featureText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.featureText = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "f-label",
    on: {
      "click": _vm.setFeatureStyle
    }
  }, [_vm._v("Add")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d88885c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Annotations.vue
// module id = 629
// module chunks = 2